import React from "react";
import { postRequest } from "./QuoteApiService";

export const getSubcontractorsTypeahead = (rec) => {
  return new Promise((resolve, reject) => {
    try {
      // do an SDK, DB call or API endpoint axios call here and return the promise.
      postRequest('GetSubcontractorsTypeahead/', rec)
      .then((res) => {
        console.log("GetSubcontractorsTypeahead > axios res=", res);
        //const persons = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        console.log("GetSubcontractorsTypeahead > axios err=", err);
        reject("Error in getAllUsers axios!");
      });
    } catch (error) {
      console.error("in services > GetSubcontractorsTypeahead, Err===", error);
      //reject(SYSTEM_ERROR);
    }
  });
  
}
